"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = legendClickResolver;

require("core-js/modules/es6.function.name");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _nSeriesLegendClickOptions = _interopRequireDefault(require("../n-series-legend-click-options"));

var _index = require("../index");

/**
 * An MW Visualizations chart the implements the "updateHiddenSeries" function
 * @typedef {object} MwVisualizations~UpdateHiddenSeriesChart
 * @property {function} updateHiddenSeriesIndices - A function that updates the current hidden series. Takes an array of numbers as a parameter
 */

/**
 * A function that resolves a named legend click handler, or passes appropriate options to a passed function
 *
 * @param {object} options - Base options object
 * @param {MwVisualizations~UpdateHiddenSeriesChart} options.chart - An MW Visualizations chart that implements the 'updateHiddenSeriesIndices' function
 * @param {SeriesData[]} options.chartData - The data for the passed chart
 * @param {object} options.chartOptions - The options for the passed chart
 * @param {function|MwVisualizations~LegendClickHandlers|undefined} - The 'onLegendClick' function from the chart options
 *
 * @returns {CallableFunction} A callback function that can be passed to Highcharts
 */
function legendClickResolver(_ref) {
  var chart = _ref.chart,
      chartData = _ref.chartData,
      chartOptions = _ref.chartOptions,
      onLegendClick = _ref.onLegendClick;

  if ((0, _typeof2.default)(chart) !== 'object') {
    throw new TypeError("chart must be a valid chart. Provided: ".concat(chart));
  }

  if (typeof chart.updateHiddenSeriesIndices !== 'function') {
    throw new TypeError("chart must impliment the \"updateHiddenSeriesIndices\" function. Provided: ".concat(chart.updateHiddenSeriesIndices));
  }

  _argumentContracts.default.assertArrayOf(chartData, Object, 'chartData');

  if ((0, _typeof2.default)(chartOptions) !== 'object') {
    throw new TypeError("chartOptions must be a valid chart option object. Provided: ".concat(JSON.stringify(chartOptions)));
  }

  if (onLegendClick) {
    var resolvedOnLegendClick = onLegendClick;

    if ((0, _index.isValidLegendClickHandler)(onLegendClick)) {
      var onLegendClickFactory = (0, _index.getFactory)(onLegendClick);
      resolvedOnLegendClick = onLegendClickFactory(chartData, chartOptions);
    }

    return function (clickEvent) {
      clickEvent.preventDefault();
      var options = new _nSeriesLegendClickOptions.default({
        chart: chart,
        seriesName: this.name //eslint-disable-line no-invalid-this

      });
      return resolvedOnLegendClick(options);
    };
  } else {
    return function (event) {
      return event.preventDefault();
    };
  }
}